import { render } from "./IciStatus.vue?vue&type=template&id=5db639f7&scoped=true&ts=true"
import script from "./IciStatus.vue?vue&type=script&lang=ts"
export * from "./IciStatus.vue?vue&type=script&lang=ts"

import "./IciStatus.vue?vue&type=style&index=0&id=5db639f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db639f7"]])

export default __exports__